var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting_main_contents",
      attrs: { id: "entry-main-content" },
      on: { scroll: _vm.scrollMenuItem }
    },
    [
      _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
        _c("i", { class: { loadding_setting: _vm.isLoadingData } })
      ]),
      _c(
        "div",
        { staticClass: "setting_heading" },
        [
          _c("h1", { staticClass: "setting_heading_title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.entrySettingProperty.TAB_HEADER) +
                "\n    "
            )
          ]),
          _c("p", { staticClass: "setting_heading_explain" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.entrySettingProperty.SUB_HEADER) +
                "\n    "
            )
          ]),
          _c(
            "button",
            {
              staticClass: "setting_btn_outline",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openModalPreview($event)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.entrySettingProperty.PREVIEW_BUTTON) +
                  "\n    "
              )
            ]
          ),
          _c("PreviewDisplay", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isVisibleModalPreview,
                expression: "isVisibleModalPreview"
              }
            ],
            attrs: {
              categories: _vm.categories,
              colors: _vm.colors,
              privacy: _vm.policy,
              button: _vm.button,
              message: _vm.message,
              masters: _vm.masters,
              entryPageName: _vm.entryPageName,
              entryOverview: _vm.entryOverview
            },
            on: { close: _vm.closeModalPreview }
          })
        ],
        1
      ),
      _c("div", { staticClass: "setting_tab" }, [
        _c("div", { staticClass: "setting_tab_nav" }, [
          _c("ul", { staticClass: "setting_tab_nav_list" }, [
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item is_active",
                attrs: { id: "t1" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.SCREEN_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.entrySettingProperty.SCREEN_TAB_TITLE) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t2" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.BUTTON_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.entrySettingProperty.BUTTON_TAB_TITLE) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t3" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.MESSAGE_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.entrySettingProperty.MESSAGE_TAB_TITLE) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t4" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.POLICY_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.entrySettingProperty.POLICY_TAB_TITLE) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t5" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.MAIL_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.entrySettingProperty.MAIL_TAB_TITLE) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t6" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.COLOR_THEME_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.entrySettingProperty.COLOR_THEME_TAB_TITLE) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t7" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.ADVANCE_SETTING_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.entrySettingProperty.ADVANCE_SETTING_TAB_TITLE
                      ) +
                      "\n          "
                  )
                ])
              ]
            )
          ])
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.SCREEN_TAB,
                expression: "navTab === SCREEN_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("ScreenTab", {
                  attrs: {
                    groupName: _vm.groupName,
                    categories: _vm.categories,
                    property: _vm.property,
                    resourceFields: _vm.resourceFields,
                    candidateCategories: _vm.candidateCategories,
                    userId: _vm.log.info.userId,
                    navTab: _vm.navTab
                  },
                  on: {
                    categoriesWasEdited: _vm.updateCategory,
                    getResourceFields: function($event) {
                      return _vm.getResourceFields(_vm.property, $event)
                    },
                    updatedProperty: _vm.updatedProperty,
                    updateResourceField: _vm.updateResourceField,
                    refreshResourceList: function($event) {
                      return _vm.refreshResourceList($event)
                    },
                    createLogger: function($event) {
                      return _vm.createLogger($event)
                    },
                    sendLogger: _vm.sendLogger,
                    updateEditingStatus: _vm.updateEditingStatus
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.BUTTON_TAB,
                expression: "navTab === BUTTON_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("ButtonTab", {
                  attrs: { button: _vm.button, buttonError: _vm.buttonError },
                  on: { updateBtnError: _vm.updateBtnError }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.MESSAGE_TAB,
                expression: "navTab === MESSAGE_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("MessageTab", {
                  attrs: {
                    message: _vm.message,
                    messageError: _vm.messageError
                  },
                  on: { updateMsgError: _vm.updateMsgError }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.POLICY_TAB,
                expression: "navTab === POLICY_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("PrivacyPolicyTab", {
                  attrs: { policy: _vm.policy, policyError: _vm.policyError },
                  on: { updatePolicyError: _vm.updatePolicyError }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.MAIL_TAB,
                expression: "navTab === MAIL_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("MailTab", {
                  attrs: {
                    mail: _vm.mail,
                    mailError: _vm.mailError,
                    humanResourceFields: _vm.resourceFields,
                    humanCandidateCategories: _vm.candidateCategories,
                    dispatchJobResourceFields: _vm.dispatchJobResourceFields,
                    dispatchJobCategories: _vm.dispatchJobCategories,
                    jobResourceFields: _vm.jobResourceFields,
                    jobCategories: _vm.jobCategories,
                    propertyDispatchJobResource: _vm.propertyDispatchJob,
                    propertyJobResource: _vm.propertyJob,
                    propertyHumanResource: _vm.propertySearchInMailTab,
                    mailReplaces: _vm.mailReplaces,
                    mailReplacesJob: _vm.mailReplacesJob,
                    mailReplacesDispatch: _vm.mailReplacesDispatch,
                    userId: _vm.log.info.userId,
                    groupName: _vm.groupName,
                    users: _vm.users,
                    hp_renkei_job: _vm.hp_renkei_job,
                    is_plan_dispatch_basic: _vm.is_plan_dispatch_basic
                  },
                  on: {
                    updateMailError: _vm.updateMailError,
                    getHumanResourceFields: function($event) {
                      return _vm.getResourceFields(
                        _vm.propertySearchInMailTab,
                        $event
                      )
                    },
                    updatedPropertyHumanResource:
                      _vm.updatedPropertySearchHumanResourceMailTab,
                    updateHumanResourceField: _vm.updateResourceField,
                    refreshHumanResourceList: function($event) {
                      return _vm.refreshResourceListInMailTab($event)
                    },
                    getDispatchJobResourceFields: function($event) {
                      return _vm.getDispatchJobResourceFields(
                        _vm.propertyDispatchJob,
                        $event
                      )
                    },
                    updatedPropertyDispatchJobResource:
                      _vm.updatedPropertyDispatchJob,
                    updateDispatchJobResourceField:
                      _vm.updateDispatchJobResourceField,
                    refreshDispatchJobResourceList: function($event) {
                      return _vm.refreshDispatchJobResourceList($event)
                    },
                    getJobResourceFields: function($event) {
                      return _vm.getJobResourceFields(_vm.propertyJob, $event)
                    },
                    updatedPropertyJobResource: _vm.updatedPropertyJob,
                    updateJobResourceField: _vm.updateJobResourceField,
                    refreshJobResourceList: function($event) {
                      return _vm.refreshJobResourceList($event)
                    },
                    updatedReplaceMail: _vm.updatedReplaceMail,
                    updatedReplaceMailJob: _vm.updatedReplaceMailJob,
                    updatedReplaceMailDispatch: _vm.updatedReplaceMailDispatch,
                    createLogger: function($event) {
                      return _vm.createLogger($event)
                    },
                    sendLogger: _vm.sendLogger,
                    updateSrollMenu: _vm.scrollMenuItem
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.COLOR_THEME_TAB,
                expression: "navTab === COLOR_THEME_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("CustomizeMode", {
                  attrs: {
                    customizeMode: _vm.customizeMode,
                    categories: _vm.categories,
                    colors: _vm.colors,
                    privacy: _vm.policy,
                    button: _vm.button,
                    message: _vm.message,
                    masters: _vm.masters,
                    entryPageName: _vm.entryPageName,
                    entryOverview: _vm.entryOverview,
                    selectedTheme: _vm.selectedTheme,
                    customizeSettings: _vm.customizeSettings,
                    groupName: _vm.groupName,
                    userId: _vm.log.info.userId,
                    token: _vm.token
                  },
                  on: {
                    updateCustomizeColors: _vm.updateColors,
                    updatedSelectedTheme: _vm.updatedSelectedTheme,
                    refreshCustomizeSetting: function($event) {
                      return _vm.refreshCustomizeSettings($event)
                    },
                    createLogger: function($event) {
                      return _vm.createLogger($event)
                    },
                    sendLogger: _vm.sendLogger
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.ADVANCE_SETTING_TAB,
                expression: "navTab === ADVANCE_SETTING_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("AdvanceSettingTab", {
                  attrs: {
                    masterStepStates: _vm.masterStepStates,
                    masterMedia: _vm.masterMedia,
                    users: _vm.users,
                    displaySetting: _vm.displaySetting,
                    hp_renkei_job: _vm.hp_renkei_job,
                    hp_renkei_entry: _vm.hp_renkei_entry
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "setting_footer", attrs: { id: "setting_footer" } },
        [
          _c(
            "button",
            {
              staticClass: "setting_btn_outline",
              on: {
                click: function($event) {
                  return _vm.cancelChangeEntryScreenSettings()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.entrySettingProperty.CANCEL_BUTTON) +
                  "\n    "
              )
            ]
          ),
          _c(
            "button",
            {
              staticClass: "setting_btn_primary",
              class: {
                setting_btn_disabled: _vm.isDisableSaveBtn || _vm.editingStatus
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.entrySettingProperty.SAVE_BUTTON) +
                  "\n    "
              )
            ]
          ),
          _vm.unSavedData
            ? _c("div", { staticClass: "setting_footer_balloon" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.entrySettingProperty.SAVE_CHANGE_DATA) +
                    "\n    "
                )
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }